import { createRouter, createWebHistory } from 'vue-router';
import { constantRouterMap } from './config';

const routes = constantRouterMap

const router = createRouter({
  history: createWebHistory(),
  routes,
});

import config from '@/config';
import { setDocumentTitle, domTitle } from '@/core/utils/domUtil';
import {
  accountStore,
  permissionStore,
} from '@/store';

const whiteList = ['login']; // no redirect whitelist
const defaultRoutePath = config.defaultRoutePath; // 默认跳转地址
router.beforeEach((to, from, next) => {
  // console.log('router', 'to:', to, 'from:', from);
  setDocumentTitle(`${domTitle}`);
  // 获取token值做判断
  if (accountStore().accessToken) {
    /* has token */
    to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`));
    // 当token存在时直接访问登录页，重定向到默认定向页
    if (to.path === '/user/login') {
      next({ path: defaultRoutePath });
    } else {
      // (当前页面刷新时)加载用户权限设置
      if (permissionStore().addRouters.length === 0) {
        // 设置vuex并获取路由权限
        accountStore().GetInfo().then(() => {
          // 设置路由权限并添加路由
          permissionStore().GenerateRoutes().then(() => {
            permissionStore().addRouters.forEach(route => {
              router.addRoute(route);
            })
            const redirect = decodeURIComponent(from.query.redirect || to.path);
            if (to.path === '/') {
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ path: permissionStore().indexRouter.path, replace: true });
              } else {
                // 跳转到目的路由
                next({ path: permissionStore().indexRouter.path });
              }
            } else {
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true });
              } else {
                // 跳转到目的路由
                next({ path: redirect });
              }
            }
          });
        });
      } else {
        next();
      }
    }
  } else {
    /* not token */
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      // 设置跳转登录页，并带入当前url
      next({ path: '/user/login', query: { redirect: to.fullPath } });
    }
  }
});


export default router; // 权限验证开启（可做目录二次验证用）
// export default new Router(staticRouter); // 权限验证关闭
